import PropTypes from 'prop-types';

export const AttendanceStatus = PropTypes.oneOf([
  'attended',
  'did_attend',
  'did_not_attend',
  'unconfirmed',
]);

export const RSVPStatus = PropTypes.oneOf([
  'awaiting_reply',
  'will_attend',
  'will_not_attend',
]);

export const CreatedFrom = PropTypes.oneOf([
  'created_from_invitation',
  'created_manually',
]);

export const StatusCounts = PropTypes.shape({
  did_attend: PropTypes.number,
  did_not_attend: PropTypes.number,
  will_attend: PropTypes.number,
  will_not_attend: PropTypes.number,
  awaiting_reply: PropTypes.number,
  unconfirmed: PropTypes.number,
});

const filter = {
  page: PropTypes.number,
  perPage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  searchCount: PropTypes.number,
  totalPages: PropTypes.number,
};

export const Filter = PropTypes.shape({
  statusCounts: StatusCounts,
  totalAttendees: PropTypes.number,
  ...filter,
});

export const MatchedUser = PropTypes.shape({
  attendanceStatus: AttendanceStatus,
  created_from: CreatedFrom,
  id: PropTypes.number,
  rsvp_status: RSVPStatus,
  session_id: PropTypes.number,
  status: PropTypes.oneOfType([AttendanceStatus, RSVPStatus]),
  user: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
});

export const MatchedAttendances = PropTypes.shape({
  data: PropTypes.arrayOf(MatchedUser),
  statusCounts: StatusCounts,
  totalAttendees: PropTypes.number,
  ...filter,
});

export const UnregisteredUser = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  resource_type: PropTypes.string,
  role: PropTypes.string,
});

export const UnregisteredAttendances = PropTypes.shape({
  data: PropTypes.arrayOf(UnregisteredUser),
  ...filter,
});

export const Session = PropTypes.shape({
  archive_number: PropTypes.number,
  archived_at: PropTypes.string,
  archived_by_user_id: PropTypes.number,
  attendance_taken: PropTypes.bool,
  created_at: PropTypes.string,
  deleted_at: PropTypes.string,
  end_time: PropTypes.string,
  event_id: PropTypes.number,
  id: PropTypes.number,
  location: PropTypes.string,
  max_attendees: PropTypes.number,
  start_time: PropTypes.string,
  time_zone: PropTypes.string,
  trainer_id: PropTypes.number,
  updated_at: PropTypes.string,
});

export const Event = PropTypes.shape({
  created_at: PropTypes.shape({
    date: PropTypes.string,
    user: PropTypes.string,
  }),
  description: PropTypes.string,
  has_invitees: PropTypes.bool,
  id: PropTypes.number,
  is_archived: PropTypes.bool,
  last_session: Session,
  last_updated_at: PropTypes.shape({
    date: PropTypes.string,
    user: PropTypes.number,
  }),
  name: PropTypes.string,
  next_session: Session,
  number_of_attendees: PropTypes.number,
  number_of_sessions: PropTypes.number,
  visbility_groups: PropTypes.arrayOf(PropTypes.string),
});
